<template>
  <section class="right-login-form">
    <p class="right-login-form-title">
      <Icon
        class="icon"
        type="md-arrow-back"
        @click="updateType === 'forget' ? $emit('on-back', 'mobile') : $emit('on-back'), doResetForm()"
      />
      <span>{{ $t('loginPage.xgmm') }}</span>
      <!-- <small v-show="updateType === 'initial'">{{ $t('loginPage.qxgcsmm') }}</small> -->
      <!-- <small :style="{ 'color': settingData.fontColor }">{{ $t('loginPage.mmydqqxgmm') }}</small> -->
    </p>
    <!-- <div v-show="updateType !== 'forget'" class="right-login-form-input" :style="{ 'background-color': settingData.inputBgColor, 'border-color': settingData.inputBorderColor }">
      <span class="input-icon">
        <svg class="icon" aria-hidden="true" :style="{ 'color': settingData.inputBorderColor }">
          <use xlink:href="#icon-kejimima"></use>
        </svg>
      </span>
      <input class="input-self" v-model="changeFormValidate.oldPassword" :placeholder="$t('loginPage.ymm')" type="password" :style="{ 'color': settingData.fontColor }"/>
    </div>-->
    <div class="right-login-form-input">
      <span class="input-icon">
        <img src="../../assets/images/unlock.svg" />
      </span>
      <input
        class="input-self"
        v-model="changeFormValidate.changePassword"
        :placeholder="$t('loginPage.xmm')"
        type="password"
      />
    </div>
    <div class="right-login-form-input">
      <span class="input-icon">
        <img src="../../assets/images/unlock.svg" />
      </span>
      <input
        class="input-self"
        v-model="changeFormValidate.changePasswordCheck"
        :placeholder="$t('loginPage.qrxmm')"
        type="password"
      />
    </div>
    <Button
      @click="doChangeConfirm"
      :disabled="!(changeFormValidate.changePassword && changeFormValidate.changePasswordCheck)"
      long
      class="login-button password-button"
    >{{ $t('qd') }}</Button>
  </section>
</template>

<script>
import { session, cookie } from '@/libs/location'
export default {
  name: 'updatePassword',
  props: {
    userInfo: {
      type: Object,
      default: () => { }
    },
    // initial,修改初始密码；forget；忘记密码下一步；expired，密码过期
    updateType: {
      type: String
    },
    // 忘记密码页面返回信息
    forgetData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      bgLayout: 'center',
      changeFormValidate: {
        oldPassword: '',
        changePassword: '',
        changePasswordCheck: ''
      }
    }
  },
  computed: {
    settingData () {
      return this.$store.state.settingData
    }
  },
  created () {
    this.bgLayout = this.$store.state.settingData.bgLayout
  },
  methods: {
    // 修改初始密码-确定
    doChangeConfirm () {
      let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
      if (
        (!reg.test(
          this.changeFormValidate.changePassword
        ) || /[\u4E00-\u9FA5]/g.test(this.changeFormValidate.changePassword))
      ) {
        this.$Message.warning(this.$t('loginPage.mmzswzmsztszf'))
        return false
      } else if (this.changeFormValidate.changePassword !== this.changeFormValidate.changePasswordCheck) {
        this.$Message.warning(this.$t('loginPage.mmbyz'))
        return false
      }
      let req = {
        id: this.updateType === 'forget' ? this.forgetData.id : JSON.parse(session.getItem('userInfo')).id,
        password: this.changeFormValidate.changePassword
      }
      this.$request.post('/sso/login/checkUpdatePwd', req).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 设置语言和皮肤
          this.$i18n.locale = data.languageSign
          // this.$store.dispatch('doChangeSkin', data.skinColor)

          session.setObject(data.sessionId)
          session.setItem('userInfo', JSON.stringify(data))
          cookie.setCookie('token', data.sessionId)
          cookie.setCookie('userInfo', JSON.stringify(data))
          this.$router.push({ name: 'duolianHome' })
        }
      })
    },
    // 重置表单
    doResetForm () {
      this.changeFormValidate.changePassword = ''
      this.changeFormValidate.changePasswordCheck = ''
      this.changeFormValidate.oldPassword = ''
    }
  }
}
</script>

<style lang="less" scoped>
.password-button {
  margin-top: 16px;
  margin-bottom: 69px;
}
</style>
